<template>
  <div>
    <q-toolbar class="text-grey">
      <q-tabs v-if="!(myNodeIndex == 0 && myPageConfigTree.length == 1 && !isValueNotEmpty(nowTreeNode?.childrens))" v-model="tab" shrink stretch narrow-indicator @update:model-value="changeTab" class="text-primary-3" active-color="primary">
        <q-tab v-for="(item,index) in myPageConfigTree" :key="item.tabName+index" :name="item.tabName" :label="item.title"/>
      </q-tabs>
      <q-space/>
    </q-toolbar>
    <q-separator/>
    <base-table v-if="isValueNotEmpty(nowTableSet)" :key="tableKey" @changePageSize="changePageSize" @changePageIndex="changePageIndex" @selectionRow="selectionRow" :tableSet="nowTableSet" @tool_click="tool_click"/>
  </div>
  <div v-if="isValueNotEmpty(nowTreeNode?.childrens)" :key="BaseTableDeepKey">
    <BaseTableDeep :pageConfigTree="nowTreeNode.childrens" :nodeIndex="myNodeIndex+1" :fPageConfig="nowTableSet" ref="baseTableDeepRef" :pageConfig="pageConfig" @tool_click="tool_click" @selectRowSearch="selectRowSearch" @changePageSize="changePageSizeDeep" @changePageIndex="changePageIndexDeep" @tabChange="tabChange"></BaseTableDeep>
  </div>

</template>

<script>
import BaseTable from '@/components/pieces/table/base.vue';
import {toRef, ref, onMounted, computed, watch, nextTick} from "vue";
import {getRandomString,isNotEmpty} from "@/tools/utils";
export default {
  props: ["pageConfigTree",'pageConfig','nodeIndex','fPageConfig'],
  components:{BaseTable},
  emits: ['tool_click','changePageSize','changePageIndex','selectRowSearch','tabChange'],
  setup(props, context) {
    let tableKey = ref(getRandomString());
    let BaseTableDeepKey = ref(getRandomString());
    let myPageConfigTree = toRef(props.pageConfigTree);
    let myPageConfig = toRef(props.pageConfig);
    let myNodeIndex = toRef(props.nodeIndex);
    let myFPageConfig= toRef(props.fPageConfig);
    let tab = ref('');
    let baseTableDeepRef = ref();
    function tool_click(item) {
      context.emit("tool_click", item);
    }
    let nowTableSet = computed(()=>{
      if(isNotEmpty(myPageConfig.value) && isNotEmpty(tab.value)){
        return myPageConfig.value[tab.value];
      }else{
        return {}
      }
    });
    let nowTreeNode = computed(()=>{
      if(isNotEmpty(myPageConfigTree.value) && isNotEmpty(tab.value)){
       let obj = myPageConfigTree.value.find((item)=>{
          return item.tabName == tab.value
        });
        return obj
      }else{
        return {}
      }
    });
    function isValueNotEmpty(value){
      return isNotEmpty(value);
    }
    function changeSizeIndexParams (){
      let params = {
        tabName:tab.value
      }
      if(isNotEmpty(myFPageConfig?.value)){ //有父级时，需要传query参数，绑定的时父级勾选行的唯一id,若没勾选行，需传空用于前端清除数据
        params.fTabName = myFPageConfig?.value?.tabName
        let query = {};
        if(myPageConfig.value[params.fTabName]['rowkey'] !== 'id'){
          if(isNotEmpty(myFPageConfig?.value?.selected)){
            query[myPageConfig.value[params.fTabName]['rowkey']] = myPageConfig.value[params.fTabName].selected[0][myPageConfig.value[params.fTabName]['rowkey']]
          }else{
            query[myPageConfig.value[params.fTabName]['rowkey']] = '';
          }
        }else{
          Object.keys(myPageConfig.value[params.tabName]['p_']).forEach(key=>{
            if((myPageConfig.value[params.fTabName].oldKey) == (myPageConfig.value[params.tabName]['p_'][key]) || (params.fTabName == myPageConfig.value[params.tabName]['p_'][key])){
              if(isNotEmpty(myFPageConfig?.value?.selected)){
                query[key] = myPageConfig.value[params.fTabName].selected[0][myPageConfig.value[params.fTabName]['rowkey']]
              }else{
                query[key] = '';
              }
            }
          });
        }
        params.query = query;
      }
      return params
    }
    function changePageSize(value){
      let params = changeSizeIndexParams();
      changePageSizeDeep(params)
    }
    function changePageIndex(value){
      let params = changeSizeIndexParams();
      changePageIndexDeep(params)
    }
    function getSelectRowFun(details){
      let tabName = baseTableDeepRef.value.returnTabName();
      let params = {
        query:{},
        tabName,
        fTabName:tab.value
      }
      if(myPageConfig.value[tab.value]['rowkey'] != 'id'){
        params.query[myPageConfig.value[tab.value]['rowkey']]=details.added ? details.rows[0][myPageConfig.value[tab.value]['rowkey']] : ''
      }else{
        Object.keys(myPageConfig.value[tabName]['p_']).forEach(key=>{
          if((myPageConfig.value[tab.value].oldKey) == (myPageConfig.value[tabName]['p_'][key]) ||  tab.value == myPageConfig.value[tabName]['p_'][key]){
            params.query[key]=details.added ? details.rows[0][myPageConfig.value[tab.value]['rowkey']] : ''
          }
        });
      }
      return params
    }
    function selectionRow(details){
      if(!isNotEmpty(nowTreeNode?.value?.childrens)){
        return
      }
      let params = getSelectRowFun(details);
      selectRowSearch(params)
    }
    function changePageIndexDeep(params){
      context.emit("changePageIndex", params);
    }
    function changePageSizeDeep(params){
      context.emit("changePageSize", params);
    }

    function selectRowSearch(params){
      context.emit("selectRowSearch", params);
    }
    function tabChange(params){
      context.emit("tabChange", params);
    }
    function changeTab(value){
      tableKey.value = getRandomString();
      BaseTableDeepKey.value = getRandomString();
      nextTick(()=>{
        if(isNotEmpty(myFPageConfig.value)){
          let params=changeSizeIndexParams();
          selectRowSearch(params);
        }else{
          tabChange({tabName: value})
        }
      });
    }
    function returnTabName(){
      return tab.value;
    }
    onMounted(()=>{
      if(isNotEmpty(myPageConfigTree.value)){
        tab.value = myPageConfigTree.value?.[0]?.tabName;
      }
    })
    return{
      tool_click,
      myPageConfigTree,
      myPageConfig,
      tab,
      nowTableSet,
      isValueNotEmpty,
      nowTreeNode,
      changePageSize,
      returnTabName,
      changePageIndex,
      selectionRow,
      baseTableDeepRef,
      selectRowSearch,
      changeTab,
      tabChange,
      myNodeIndex,
      tableKey,
      myFPageConfig,
      changePageIndexDeep,
      changePageSizeDeep,
      BaseTableDeepKey
    }
  }
}
</script>

